<template>
    <div v-loading="loading" v-show="ready">
        <div>
            <div class="container">
                <!-- header -->
                <div class="header" style="position:relative;">
                    <div class="d-sm-block d-none"
                         style="float:right;display:inline; width:400px; margin-top:0;color:#000; font-size:14px; font-family:微软雅黑;">
                        <div id="time" class="time">
                        </div>
                    </div>
                    <div class="logo"><img src="../assets/images/logo_07@2x.png" style="max-width: 100%;height: 72px;"/></div>
                </div>
            </div>
            <div class=""></div>
            <div class="position-relative" style="">
                <div id="" class="login-wrap-bg"></div>
                <div class="login">
                    <div class="container position-relative">
                        <div class="login-wrap">
                            <div class="login-bg">
                                <form class="fm-v clearfix" @submit.prevent="submitForm"
                                      action="/">
                                    <div class="login-table">
                                        <div id="iptUsername">
                                            <div class="login-group">
                                                <input v-model="login.id" type="text" autocomplete="off"
                                                       placeholder="学号/工号" class="input" value="" required>
                                                <div class="wrapper"><i class="fa fa-user"></i> &nbsp;</div>
                                            </div>
                                        </div>
                                        <div class="spacer"></div>
                                        <div id="iptPassword">
                                            <div class="login-group">
                                                <input v-model="login.password" type="password"
                                                       autocomplete="off"
                                                       placeholder="密码" class="input" value="" required>
                                                <div class="wrapper"><i class="fa fa-lock"></i> &nbsp;</div>
                                            </div>
                                        </div>

                                        <div id="submitButton" class="inputSubmitButton">
                                            <button type="submit" class="login-btn btn btn-block mt-4"
                                                    style="font-size:20px;">登 录
                                            </button>
                                        </div>

                                        <div class="row mt-4 link d-flex justify-content-around">
                                            <div class="">
                                                <a href="https://qy.weixin.qq.com/cgi-bin/wap_getnewsmsg?action=get&__biz=MzA3ODY2NzIyMA==&mixuin=MjI5NzgwNzUwODY4Mzk2NzI5OA==&mid=10000401&idx=1&sn=cc1e531ae0d1e9ba119fd0236955fc6a">NetID认证激活</a>
                                            </div>
                                            <!-- <div style="display: none;"><a class="text-info" href="javascript:void(0);" @click="jumpToWechatCorp"><b>微信扫码登录</b></a> </div> -->
                                            <div class="">
                                                <a href="https://qy.weixin.qq.com/cgi-bin/wap_getnewsmsg?action=get&__biz=MzA3MjY2NjUyNw==&mixuin=MjI5NzgwNzUwODY5Mjk2NzMwMA==&mid=10000389&idx=1&sn=853980d2bc8e8fe567aa4a7aa14960b7&scene=1&pass_ticket=ojKq6OU9sQAQzJfS%2Fwzu8RUjH7z5z%2Be9Nq2mZxyJDBE%3D">忘记密码?</a>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="hint">
                                <div class="row">
                                    <div class="col-6 text-left">
                                        <a href="https://meeting.tsied.com/tenant/sufe/manuals/%E4%BA%91%E8%A7%86%E9%A2%91%E4%BC%9A%E8%AE%AE%E6%9C%8D%E5%8A%A1%E6%89%8B%E5%86%8Cv2.pdf"
                                           target="_blank">
                                            <i class="fa fa-book"></i> 使用手册</a>
                                    </div>
                                    <div class="col-6 text-right">
                                        <a href="/assets/QnA.pdf"
                                           target="_blank">
                                            <i class="fa fa-question-circle"></i> Q&A</a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>

        <div class="footer">
            <div class="container">
                <div class="row">
                    <div class="col-sm-6">
                        <p>Copyright © 上海财经大学教育技术中心 all rights reserved</p>
                        <p>地址：上海市国定路777号 邮编:200433</p>
                        <p>联系电话: 65904408 Email:bb@shufe.edu.cn</p>
                    </div>
                    <div class="col-sm-6">
                        <div class="picture">
                            <img src="../assets/images/link_logo6.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import VueCookie from "vuecookie";
    import qywxCommon from "../common/mixins/qywxCommon"

    export default {
        name: "sign-in-sufe",
        mixins:[qywxCommon],
        data() {
            return {
                loading: false,
                login: {
                    id: '',
                    password: ''
                },
                ready:false
            }
        },
        created() {
            const vm = this;
            if (this.$route.query.schoolid === '74942') { //大讲堂跳转
                this.loading = true;
                this.$api('SUFEDJTLOGIN',this.$route.query,1).then((res)=>{
                    VueCookie.set('SUFEDJTLOGIN',1,{expires:'1D'});

                    const ret = res.data.data;
                    if (ret.user) { // 已经登录了，则进入
                        //vm.$messageBox.error('Has User');
                        vm.setUserInfo(ret.user);
                        vm.$router.replace("/");
                    } else {// 如果都不行，则进行网络登录
                        this.loading = false;
                        vm.$messageBox.error(ret.message);
                        vm.$router.replace("/");
                    }
                });
            }
        },
        mounted(){
          this.qywxWebLogHandler();
        },
        computed: {
            ...mapState(['user', 'process']),

        },
        methods: {
            ...mapMutations('user', ['setUserInfo']),
            submitForm() {
                const vm = this;
                if (!vm.login.id) {
                    vm.$message.error('必须要输入学号/工号。');
                } else {
                    vm.$api('SSO', vm.login, true).then(response => {
                        if (response.data.success) {
                            vm.setUserInfo(response.data.data);
                            vm.$router.replace("/");
                        }
                    });
                }
            },

        },
    }
</script>

<style scoped lang="scss">

    .header {
        min-height: 120px;
        background-color: white;
    }

    .header img {
        vertical-align: middle;
    }

    .logo {
        height: 120px;
        display: table-cell;
        vertical-align: middle;
    }

    .time {
        height: 120px;
        font-size: 26px;
        color: #E65100;
        line-height: 78px;
        text-align: right;
        padding-right: 5px;
        display: none;
    }

    .text-time {
        color: #E65100;
        font-weight: bold;
    }

    .show_help {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 999
    }

    .show_help_content .title {
        font-size: 28px;
        text-align: left;
        margin-bottom: 5px;
    }

    .show_help_content .body {
        font-size: 16px;
        text-align: left;
    }

    .slide {
        width: 100%;
        height: 477px;
        background-size: cover;
        background-position: center;
    }

    .login {
        position: absolute;
        top: 0;
        width: 100%;
    }

    .login-wrap {
        width: 453px;
        height: 466px;
        position: relative;
        margin-top: 91px;
        float: right;
        margin-right: 62px;
    }

    .login-wrap-bg {
        background: url('../assets/images/bg_07.jpg') no-repeat center;
        height: 676px
    }

    .login-bg {
        width: 100%;
        height: 404px;
        background: url('../assets/images/login_bg.png') no-repeat center;
        position: absolute;

    }

    .login-table {
        margin-top: 130px;
        width: 330px;
        height: 220px;
        margin-left: 57px;
        border-spacing: 0;
    }

    .login-group {
        height: 40px;
        position: relative;
    }

    .login-group .input {
        height: 42px;
        box-sizing: border-box;
        border-radius: 3px;
        border: 1px solid #e6e6e6;
        color: black;
        font-size: 14px;
        width: 100%;
        padding-left: 34px;
        transition: all 0.2s ease-in;
    }

    input::-webkit-input-placeholder {
        color: #e2e2e2;
    }

    input::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: #e2e2e2;
    }

    input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        color: #e2e2e2;
    }

    input:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #e2e2e2;
    }

    input.input:focus {
        border-color: #03a9f4;
        outline: none;
        box-shadow: none;
    }

    input.input:hover {
        border-color: #03a9f4;
        outline: none;
        box-shadow: none;
    }

    .login-group .wrapper {
        color: #e2e2e2;
        text-align: center;
        width: 24px;
        line-height: 40px;
        position: absolute;
        top: 1px;
        left: 8px;
        transition: all 0.2s ease-in;
    }

    .login-group:hover .wrapper {

        color: #03a9f4;
    }

    .login-table a {
        color: #919191;
        font-size: 12px;
        text-decoration: none;
        transition: all 0.2s ease-in;
    }

    .login-table a:hover {
        color: #aaaa;
        text-decoration: none;
    }

    .spacer {
        height: 20px;
    }

    .login-btn {
        background-color: #e39949;
        color: white;
        transition: all 0.2s ease-in;
    }

    .login-btn:hover {
        background-color: #ffb74d;
        color: white;
    }

    .hint {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding-left: 57px;
        padding-right: 57px;
    }

    .hint a {
        font-size: 16px;
        color: #e0e0e0;
        transition: all 0.2s ease-in;
    }

    .hint a:hover {
        font-size: 16px;
        color: #fff;
        text-decoration: none;
    }

    .footer {
        min-height: 180px;
        background-color: white;
        color: #333;
        padding-top: 40px;
    }

    .footer .picture {
        margin-top: 30px;
        text-align: right;
        margin-right: 33px;
    }

    .footer .picture img {
        max-width: 100%;
    }

    .footer p {
        line-height: 36px;
        font-size: 13px;
        color: #666;
        padding: 0;
        margin: 0;
    }


    @media (max-width: 767.98px) {
        .login-wrap {
            width: 100%;
            height: 466px;
            position: relative;
            margin: 91px auto 0;
            float: none;
        }

        .login-table {
            width: auto;
            margin-right: 20px;
            margin-left: 20px;
        }

        .footer {
            text-align: center;
        }
        .footer .picture {
            text-align: center;
        }
    }

</style>
